import React from "react";
import { useSelector } from 'react-redux';
import { floral } from '../language';

const ABOUT_IMAGE = '/img/site_imgs/studio_des.jpg';

function AboutStudio(props) {
  const languageEN = useSelector((state) => {
    return state.app.languageEN;
  });
  const language = languageEN ? 'en' : 'ch';

  return (
    <div id="about" className="lf-bg-tint lf-section-anchor">
      <div className="lf-editorial lf-section py-5">
        <div className="row align-items-center">
          <div className="col-lg-6 lf-reveal lf-about-image-col">
            <div className="lf-image-frame" style={{ aspectRatio: '4 / 5' }}>
              <img src={ABOUT_IMAGE} alt="Close-up of a cascading white bridal bouquet with roses, calla lilies, and trailing greenery." loading="lazy" decoding="async" />
            </div>
          </div>
          <div className="col-lg-6 lf-reveal mt-4 mt-lg-0">
            <p className="lf-eyebrow">{floral.about.eyebrow[language]}</p>
            <h2 className="lf-section-heading" style={{ fontSize: '2.35rem', lineHeight: 1.26, letterSpacing: '-0.04em' }}>
              {floral.about.title[language]}
            </h2>
            <p className="mt-4" style={{ color: 'var(--lf-muted)', lineHeight: 1.6 }}>
              {floral.about.body[language]}
            </p>
            <a
              className="lf-btn-secondary mt-3"
              onClick={() => {
                const target = document.getElementById('approach');
                if (target) {
                  target.scrollIntoView({ behavior: 'smooth' });
                }
              }}
            >
              {floral.about.learnMore[language]}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export { AboutStudio };
